import { Game, getActiveGames } from "api/active-games/get-active-games";
import subscribeToStream from "api/utils/subscribe-to-stream";

type SubscribeArgs = {
  onActiveGamesUpdate: (games: Game[] | null) => void;
};
type CleanupFn = () => void;

export const subscribeToActiveGamesStream = ({ onActiveGamesUpdate }: SubscribeArgs): CleanupFn => {
  return subscribeToStream<Game[]>({
    resourcePath: "/api/active-games/stream",
    fetchLatest: () => getActiveGames(),
    parseMessage: (data) => data as Game[],
    onUpdate: onActiveGamesUpdate,
  });
};

export default subscribeToActiveGamesStream;
